module.exports = __webpack_public_path__ + "img/82.e113a9d4.svg";